<template>
  <div class="page-content">
    <div class="page-course-header d-flex d-flex-middle d-flex-between" style="align-items: end;">
      <p class="evaluation_pageTitle evaluation_pageTitleb ">
        <span class="evaluation_pageTitles">知识点测验</span>
      </p>
    </div>
    <div class="evaluation_base_tabs d-flex d-flex-middle d-flex-between">
      <div class="d-flex d-flex-middle">
        <p v-for="(e, i) in tabs" :key="i" @click="tabClick(e)" :class="{ 'on': e.id == isOn }">{{ e.name }}<i
            :class="{ 'bgColor': e.id == isOn }"></i></p>
      </div>
      <div style="padding:0 30px;">
        <el-form ref="form" :model="form" label-width="auto">
          <el-form-item label="考次" size="small" class="mb0">
            <el-select v-model="form.examConfigId" placeholder="请选择考次" @change="changeExamConfig">
              <el-option :label="item.examTimeCode" :value="item.id" v-for="(item, index) in examConfigList"
                :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="enroll-time" v-if="currentExamConfig">
      测评时间：{{ formatDateTime(currentExamConfig.abilityStartTime) }} -
      {{ formatDateTime(currentExamConfig.abilityEndTime) }}
    </div>
    <div class="evaluation_coursePage_list" v-if="list.length > 0">
      <div class="evaluation_coursePage_li d-flex d-flex-middle d-flex-between" v-for="(c, i) in list" :key="i">
        <div class="evaluation_coursePage_li_l">
          <div class="evaluation_coursePage_li_info ">
            <div class="evaluation_coursePage_li_info_name txtOver">
              <p>{{ c.courseCode + '-' + c.courseName }}</p>
              <p>{{ '完成/总题量：' + (c.replyNum || 0) + '/' + (c.sumNum || 0) }}</p>
              <p v-if="c.startTime && c.endTime">{{ '答题时间：' + c.startTime + '～' + c.endTime }}</p>
            </div>
            <div class="evaluation_coursePage_li_info_line d-flex d-flex-middle">
              {{ c.remark }}
            </div>
          </div>
        </div>
        <template v-if="inAbilityTime">
          <a href="javascript:void(0);" @click="toStudy(c)" class="evaluation_BoxLi_btn bgColor"
            style="background-color:#0065BA;" v-if="c.status == 'NOTSTART'">开始测评</a>
          <a href="javascript:void(0);" @click="toStudy(c)" class="evaluation_BoxLi_btn bgColor"
            style="background-color:#0065BA;" v-if="c.status == 'STARTED'">继续测评</a>
          <a href="javascript:void(0);" @click="toStudyRemark(c)" class="evaluation_BoxLi_btn bgColor"
            style="background-color:#0065BA;" v-if="c.status == 'SUBMITTED'">重新测评</a>
          <a href="javascript:void(0);" @click="toStudyView(c)" class="evaluation_BoxLi_btn bgColor"
            style="background-color:#0065BA;" v-if="c.status == 'SUBMITTED'">查看</a>
        </template>
        
      </div>
    </div>
    <div v-else>
      <Empty></Empty>
    </div>
    <CourseOpenTip ref="courseOpenTip" />
    <FightersAgreementDialog
      ref="FightersAgreementDialog"
      @confirm="onPledgeConfirm"
    />
  </div>
</template>

<script>
import { mapState } from "vuex"
import Empty from "@/components/Empty.vue";
import CourseOpenTip from '@/components/CourseOpenTip.vue'
import FightersAgreementDialog from "@/components/FightersAgreementDialog.vue";
import { getServerCurrentTime } from "@/utils/utils.js";
import { checkCourseOpened } from '@/utils/courseOpen';
import { ensureEnrolledPaid } from '@/utils/studyFee';


export default {
  components: {
    Empty,
    CourseOpenTip,
    FightersAgreementDialog,
  },
  name: "evaluation",
  data () {
    return {
      isOn: '0',
      tabs: [
        { id: '0', name: '待测验' },
        { id: '1', name: '已完成' },
      ],
      list: [],
      tsItem: {},
      examConfigList: [],
      form: {
        examConfigId: '',
      },
      currentTime: null,
    };
  },
  computed: {
    ...mapState(['user']),
    currentExamConfig () {
      return this.examConfigList.find(item => item.id === this.form.examConfigId) || null
    },
    inAbilityTime () {
      if (!this.currentExamConfig || !this.currentTime) return false
      const { abilityStartTime, abilityEndTime } = this.currentExamConfig
      if (!abilityStartTime || !abilityEndTime) return true
      const cur = this.currentTime instanceof Date ? this.currentTime.getTime() : this.parseTime(this.currentTime)
      const start = this.parseTime(abilityStartTime)
      const end = this.parseTime(abilityEndTime)
      if (!cur || !start || !end) return false
      return cur >= start && cur <= end
    }
  },
  async created () {
    await this.refreshCurrentTime();
    this.getExamConfig();
  },
  methods: {
    formatDateTime (time) {
      if (!time) return '-'
      return String(time)
    },
    parseTime (time) {
      if (!time) return null
      const str = String(time).replace(/-/g, '/')
      const t = new Date(str).getTime()
      return isNaN(t) ? null : t
    },
    async refreshCurrentTime () {
      this.currentTime = await getServerCurrentTime(this.$http)
    },
    async getExamConfig () {
      await this.$http.get('/student/pc/getSchoolExamConfig', {}).then((res) => {
        this.examConfigList = res
        this.form.examConfigId = res[0]?.id
        this.getData();
      })
    },
    async getData () {
      if (!this.form.examConfigId) return
      this.$http.get('/student/pc/study/promise/record/isSigned?examConfigId=' + this.form.examConfigId, {
      }).then((res) => {
        if (!res) {
          this.$refs.FightersAgreementDialog.open(this.form.examConfigId);
        } else {
          this.$http.get('/student/pc/evaluation/record', { examConfigId: this.form.examConfigId }).then((res) => {
            if (this.isOn == '0') {
              // 待测验
              this.list = res.filter(item => item.status === 'NOTSTART' || item.status === 'STARTED')
            } else {
              // 已完成
              this.list = res.filter(item => item.status !== 'NOTSTART' && item.status !== 'STARTED')
            }
          })
        }
      })
    },
    tabClick (e) {
      this.isOn = e.id
      this.getData();
    },
    async toStudy (e) {
      // if (!checkCourseOpened(e.isOpen, this)) {
      //   return
      // }
      this.tsItem = e
      const opened = await ensureEnrolledPaid(this, this.form.examConfigId, e.courseId, '该课程尚未开通，请先开通')
      if (!opened) return
      this.toStudys(e)
    },
    toStudys (e = this.tsItem) {
      this.$router.push({
        path: '/evaluationPaper',
        query: {
          id: e.configId,
        }
      })
    },
    // 重做
    async toStudyRemark (e) {
      // if (!checkCourseOpened(e.isOpen, this)) {
      //   return
      // }
      const opened = await ensureEnrolledPaid(this, this.form.examConfigId, e.courseId, '该课程尚未开通，请先开通')
      if (!opened) return
      const formData = new FormData();
      formData.append("evaluationConfigId", e.configId);

      // this.$http.put('/student/pc/evaluation/record', formData, { "Content-Type": "multipart/form-data", }).then((res) => {
      this.$http.put('/student/pc/evaluation/record?evaluationConfigId='+e.configId,).then((res) => {
        if (res) {
          this.toStudys(e)
        }
      })
    },
    toStudyView (e) {
      // if (!checkCourseOpened(e.isOpen, this)) {
      //   return
      // }
      this.$router.push({
        path: '/evaluationPaperDetails',
        query: {
          id: e.configId,
        }
      })
    },
    async changeExamConfig () {
      await this.refreshCurrentTime();
      this.getData();
    },
    onPledgeConfirm () {
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  margin: 0;
}

.mb0 {
  margin-bottom: 0;
}

.evaluation_pageTitle {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
}

.evaluation_base_tabs {
  width: 100%;
  height: 40px;

  p {
    width: 80px;
    text-align: center;
    margin: 0 30px;
    font-size: 16px;
    cursor: pointer;
    line-height: 40px;
    position: relative;
    color: rgb(51, 51, 51);
  }

  i {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 4px;
    background-color: transparent;
    background: transparent;
  }

  .on {
    color: #0065BA;
  }

  .bgColor {
    background: #0065BA;
  }
}

.evaluation_coursePage_list {
  box-sizing: border-box;
  padding: 15px 30px 1px 30px;
}

.evaluation_coursePage_li {
  width: 100%;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #E3E3E3;
  box-sizing: border-box;
  padding: 12px 10px;
  margin-bottom: 30px;

  .evaluation_coursePage_li_l {
    // width: 100%;
  }

  .evaluation_coursePage_li_info {
    margin-left: 15px;

    .evaluation_coursePage_li_info_name {
      p{
        font-size: 14px;
        color: #666;
        line-height: 30px;
      }
    }

    .txtOver {
      width: 710px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      word-break: break-all;
    }

  }

}

.evaluation_BoxLi_btn {
  width: 74px;
  height: 28px;
  line-height: 28px;
  border-radius: 14px 14px 14px 14px;
  text-align: center;
  color: #fff;
}

.enroll-time {
  margin-left: 12px;
  color: #666;
  font-size: 13px;
  margin: 20px 0 0 30px;
}
</style>
